import { getEnvironment } from ".";

const configs = {
  local: {
    ENV: "Development",
    CLIENT_ID: "0oafd6poc41dgEipA2p7",
    // PGAPI_URL: "https://prjwsapi-dev.emerson.com",
    PGAPI_URL: 'http://127.0.0.1:8000',
    CADMIN_URL: "https://cloudadminfapi-dev.emerson.com",
    // REPORT_API_URL: "https://sandbox.gateway.emerson.com/api/aslgrp/rpthub-dev/process/v1/api",
    REPORT_API_URL: "https://sandbox.gateway.emerson.com/api/aslgrp/rpthub-dev/process/v1/api/v1",
    REACT_APP_AUTOSOLEAPPS: "https://prjwsapp-dev.emerson.com",
    REACT_APP_CONFIGIT: "https://configurator-dev.emerson.com",
    //"https://configurator-dev.emerson.com"
    // REACT_APP_AUTOSOLEAPPS: "https://prjwsapp-stg.emerson.com",
    REACT_APP_GA_TRACKING_CODE: "UA-221814656-1",
    PPA_URL: "https://ppafapi-dev.azurewebsites.net/v1/api/ppa",
    MSOL_DP_FLOW_PA_ACTIVE: "Y",
    MSOL_FLOW_PA_ACTIVE: "Y",
    AUTH0_DOMAIN: "https://authdev.emerson.com",
    AUTH0_CLIENT_ID: "29plBYCQpKwlIrFkkzGXMRwF6b622w8L",
    SIZING_CORE_ORIGIN: "https://dev.www.emerson.com",
    CONFIGIT_ROUTING_CHECK_API: "https://configurator-dev.emerson.com",
    ORDS_CREATE_QUOTE_API: "https://ords.dev.emerson.com"
  },
  development: {
    ENV: "Development",
    CLIENT_ID: "0oafd6poc41dgEipA2p7",
    PGAPI_URL: "https://prjwsapi-dev.emerson.com",
    // PGAPI_URL: 'http://127.0.0.1:8000',
    CADMIN_URL: "https://cloudadminfapi-dev.emerson.com",
    // REPORT_API_URL: "https://sandbox.gateway.emerson.com/api/aslgrp/rpthub-dev/process/v1/api",
    REPORT_API_URL: "https://sandbox.gateway.emerson.com/api/aslgrp/rpthub-dev/process/v1/api/v1",
    REACT_APP_AUTOSOLEAPPS: "https://prjwsapp-dev.emerson.com",
    REACT_APP_CONFIGIT: "https://configurator-dev.emerson.com",
    REACT_APP_GA_TRACKING_CODE: "UA-221814656-1",
    PPA_URL: "https://ppafapi-dev.azurewebsites.net/v1/api/ppa",
    MSOL_DP_FLOW_PA_ACTIVE: "Y",
    MSOL_FLOW_PA_ACTIVE: "Y",
    AUTH0_DOMAIN: "https://authdev.emerson.com",
    AUTH0_CLIENT_ID: "29plBYCQpKwlIrFkkzGXMRwF6b622w8L",
    SIZING_CORE_ORIGIN: "https://dev.www.emerson.com",
    CONFIGIT_ROUTING_CHECK_API: "https://configurator-dev.emerson.com",
    ORDS_CREATE_QUOTE_API: "https://ords.dev.emerson.com"
  },
  stage: {
    ENV: "Staging",
    CLIENT_ID: "0oafd6rvx2Rbl3Jxb2p7",
    PGAPI_URL: "https://prjwsapi-stg.emerson.com",
    // CADMIN_URL: "https://cloudadminfapi-stg.azurewebsites.net",
    CADMIN_URL: "https://cloudadminfapi-stg.emerson.com",
    // REPORT_API_URL: "https://sandbox.gateway.emerson.com/api/aslgrp/rpthub-p/v1/api",
    REPORT_API_URL: "https://sandbox.gateway.emerson.com/api/aslgrp/rpthub-p/v1/api/v1",
    // REACT_APP_AUTOSOLEAPPS: "https://prjwsapp-stg.azurewebsites.net",
    REACT_APP_AUTOSOLEAPPS: "https://prjwsapp-stg.emerson.com",
    REACT_APP_CONFIGIT: "https://configurator-dev.emerson.com",
    REACT_APP_GA_TRACKING_CODE: "UA-221814656-1",
    MSOL_DP_FLOW_PA_ACTIVE: "Y",
    MSOL_FLOW_PA_ACTIVE: "Y",
    AUTH0_DOMAIN: "https://authuat.emerson.com",
    AUTH0_CLIENT_ID: "uqg5CAL9UfsPjtFAc37NKEflX0JN6gow",
    SIZING_CORE_ORIGIN: "https://stage.www.emerson.com",
    CONFIGIT_ROUTING_CHECK_API: "https://configurator-dev.emerson.com",
    ORDS_CREATE_QUOTE_API: "https://ords.dev.emerson.com"
  },
  production: {
    ENV: "Production",
    CLIENT_ID: "0oajobfd11DHcwfy42p7",
    // PGAPI_URL: "https://prjwsapi.azurewebsites.net",
    PGAPI_URL: "https://myprojectworkspaceapi.emerson.com",
    // CADMIN_URL: "https://cloudadminfapi.azurewebsites.net",
    CADMIN_URL: "https://ssocloudadminapi.emerson.com",
    REPORT_API_URL: "https://apim.gateway.emerson.com/api/aslgrp/rpthub-p/v1/api/v1",
    // REACT_APP_AUTOSOLEAPPS: "https://prjwsapp.azurewebsites.net",
    REACT_APP_AUTOSOLEAPPS: "https://myprojectworkspaceapp.emerson.com",
    REACT_APP_GA_TRACKING_CODE: "UA-221814656-1",
    MSOL_DP_FLOW_PA_ACTIVE: "Y",
    MSOL_FLOW_PA_ACTIVE: "Y",
    AUTH0_DOMAIN: "https://auth.emerson.com",
    AUTH0_CLIENT_ID: "mNy85eaJbpTJrs4SqY6I89MFoEp3XENZ",
    SIZING_CORE_ORIGIN: "https://www.emerson.com",
    CONFIGIT_ROUTING_CHECK_API: "https://configurator.emerson.com",
    ORDS_CREATE_QUOTE_API: "https://ords.dev.emerson.com"
  },
  productionbeta: {
    ENV: "production",
    CLIENT_ID: "0oajobfd11DHcwfy42p7",
    // PGAPI_URL: "https://prjwsapi.azurewebsites.net",
    PGAPI_URL: "https://myprojectworkspaceapi.emerson.com",
    // CADMIN_URL: "https://cloudadminfapi.azurewebsites.net",
    CADMIN_URL: "https://ssocloudadminapi.emerson.com",
    // REPORT_API_URL: "https://apim.gateway.emerson.com/api/aslgrp/rpthub-p/v1/api",
    REPORT_API_URL: "https://apim.gateway.emerson.com/api/aslgrp/rpthub-p/v1/api/v1",
    // REACT_APP_AUTOSOLEAPPS: "https://prjwsapp.azurewebsites.net",
    REACT_APP_AUTOSOLEAPPS: "https://myprojectworkspaceapp.emerson.com",
    REACT_APP_GA_TRACKING_CODE: "UA-221814656-1",
    MSOL_DP_FLOW_PA_ACTIVE: "Y",
    MSOL_FLOW_PA_ACTIVE: "Y",
    AUTH0_DOMAIN: "https://auth.emerson.com",
    AUTH0_CLIENT_ID: "mNy85eaJbpTJrs4SqY6I89MFoEp3XENZ",
    SIZING_CORE_ORIGIN: "https://www.emerson.com",
    CONFIGIT_ROUTING_CHECK_API: "https://configurator-dev.emerson.com",
    ORDS_CREATE_QUOTE_API: "https://ords.dev.emerson.com"
  },

};

const environment = getEnvironment();
const config = configs[environment];

export default config;